import { Component, Input, OnInit,  ViewEncapsulation } from '@angular/core';
import {  NG_VALUE_ACCESSOR } from '@angular/forms';

import { OptionsListService } from '../_services/options-list.service';
import { WOption } from '../interfaces';

@Component({
    selector: 'suggest-multiselect',
    templateUrl: './jer-suggest-multiselect.component.html',
    styleUrls: ['./jer-suggest-multiselect.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: JerSuggestMultiselectComponent,
            multi: true,
        }
    ],
    standalone: false
})
export class JerSuggestMultiselectComponent implements OnInit {

	/*
		OK so attributes I need :
		[(ngModel)] to know where to store the selected items, and the other way, where to look to populate the component
		[what] to know what to suggest (optional, we can just call Solr to suggest anything)
	*/

	// @ts-ignore It's defined in the template
	@Input() what: string

	public componentId: number = Math.random(); // Little hack to avoid opening all the suggestions drawers of all the same components on the page. I'm giving each one an ID

	public inputValue: string = "";

	constructor(public ols: OptionsListService) {

	}

	ngOnInit(): void {
		const l = `JerSMS ngOnInit() - `
		// console.log(`${l}what=`, this.what)
	}


	onKeyup($event: KeyboardEvent): void {

		const l = `JerSMS onKeyup() - `

		// // console.log(`${l}$event.code : `, $event.code)

		if (!($event.code || $event.key)) return; // That's when we click a suggestion, I don't want to suggest anything

		// console.log(`${l}$event.code || $event.key = `, $event.code || $event.key);

		// console.log(`${l}calling ols.suggest($event, ${this.what}, ${this.componentId})`);

		this.ols.suggest($event, this.what, this.componentId)
	}


	async onModelChange(): Promise<void> {

		const l = `JerSMS onModelChange() - `;

		await new Promise(r => setTimeout(r));

		// console.log(`${l}inputValue=`, this.inputValue)

		// console.log(`${l}this.ols.suggestions = `, this.ols.suggestions);

		const suggestion: WOption = this.ols.suggestions.find(s => s.label2 ? (s.label2 === this.inputValue) : (s.label === this.inputValue)) as WOption;

		// console.log(`${l}Suggestion = `, suggestion);

		if (!suggestion) return; // That's when we type one letter in the input field, so the value is just "f", not "(FR) INPI"

		// console.log(`${l}this.innerValue before = `, this.innerValue);

		if (!this.innerValue.find(obj => obj.value === suggestion.value)) {
			// delete suggestion.label2 // Nope, on't delete it, it is needed when hovering a label. When we hover "10" we want to see the full description of the Nice class
			delete suggestion.info // This field is only used as an index filter, for faster filtering. No need to carry this around either
			this.innerValue.push(suggestion) // This actually pushes things into ngModel :D
		}

		// console.log(`${l}this.innerValue after = `, this.innerValue);

		this.inputValue = "";

		// console.log(`${l}Clearing suggestions ~~~~~~~~`);
		this.ols.suggestions = [] // Closing the suggestion list
		this.onChange(this.innerValue);
	}


	remove(obj: WOption) {
		this.innerValue = this.innerValue.filter(o => o.value !== obj.value)
		this.onChange(this.innerValue);
	}








	/*
		Below : all the dark magic required to implement [(ngModel)] - Don't touch anything
		https://stackblitz.com/edit/angular-custom-comp-ngmodel
	*/

	private innerValue: WOption[] = [];
	// @ts-ignore shut up
	private onChange: (_) => void;
	// @ts-ignore shut up
	private onTouched: () => void;

	get value() {
		return this.innerValue;
	}

	set value(v) {
		if (this.innerValue != v) {
			this.innerValue = v;
			this.onChange(v);
		}
	}

	onBlur() {
		this.onTouched();
	}

	// @ts-ignore shut up
	registerOnChange(fn) {
		this.onChange = fn;
	}

	// @ts-ignore shut up
	registerOnTouched(fn) {
		this.onTouched = fn;
	}

	// @ts-ignore shut up
	writeValue(v) {
		const l = `jerSuggest writeValue() - `
		if (v && this.innerValue != v) {
			// // console.log(`${l}setting this.innerValue=`, deepClone(v))
			this.innerValue = v;
		}
	}

	/*
		END [(ngModel)]
	*/
}
